import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';

import { SvgLibraryIcon } from '@finnairoyj/fcom-ui-styles';

import { BUS_CONNECTION_LOCATION_CODES, RAIL_AND_FLY_LOCATION_CODES } from '@fcom/core/constants';

interface Airport {
  dateTime: string;
  city: string;
  airportCode: string;
  airport: string;
}

/**
 * @Unstable
 * Warning! This component is in active development and is not production ready.
 *
 * Documentation can be found in `storybook/stories/flights/timeline.stories.mdx`
 */
@Component({
  selector: 'fcom-timeline',
  templateUrl: './timeline.component.html',
  styleUrls: ['./timeline.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class TimelineComponent {
  /**
   * Object containing the information for the Departure airport, including
   * - city name
   * - airport name
   * - airport code
   * - formatted dateTime of departure @example "08:45 Thu"
   *
   * Required
   */
  departure = input.required<Airport>();

  /**
   * Object containing the information for the Arrival airport, including
   * - city name
   * - airport name
   * - airport code
   * - formatted dateTime of arrival @example "08:45 Thu"
   *
   * Required
   */
  arrival = input.required<Airport>();

  isByBusOnly = input(false);
  isByTrainOnly = input(false);

  departureIcon = computed<SvgLibraryIcon>(() => {
    if (this.isByBusOnly()) {
      return SvgLibraryIcon.BUS;
    }
    if (this.isByTrainOnly()) {
      return SvgLibraryIcon.TRAIN;
    }
    return this.getIcon(this.departure().airportCode, true);
  });

  arrivalIcon = computed<SvgLibraryIcon>(() => {
    if (this.isByBusOnly()) {
      return SvgLibraryIcon.BUS;
    }
    if (this.isByTrainOnly()) {
      return SvgLibraryIcon.TRAIN;
    }
    return this.getIcon(this.arrival().airportCode, false);
  });

  private getIcon(airportCode: string, isDeparture: boolean): SvgLibraryIcon {
    if (BUS_CONNECTION_LOCATION_CODES.includes(airportCode.toUpperCase())) {
      return SvgLibraryIcon.BUS;
    }

    if (RAIL_AND_FLY_LOCATION_CODES.includes(airportCode.toUpperCase())) {
      return SvgLibraryIcon.TRAIN;
    }

    return isDeparture ? SvgLibraryIcon.DEPARTURE : SvgLibraryIcon.ARRIVAL;
  }
}
